var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
import isFunction from "lodash-es/isFunction.js";
import isObject from "lodash-es/isObject.js";
const _TTLCache = class _TTLCache {
  /** 내부 캐시 저장소 */
  cache;
  /**
   * TTLCache 인스턴스를 생성합니다.
   */
  constructor() {
    this.cache = /* @__PURE__ */ new Map();
  }
  /**
   * 캐시에 값을 저장합니다.
   *
   * @param key - 캐시 키
   * @param value - 저장할 값
   * @param ttl - 만료 시간 (초 단위). 0이면 만료 없음
   * @param uniqueKey - 고유 키. 이 값이 같은 기존 엔트리는 삭제됨
   *
   * @example
   * ```ts
   * // 300초(5분) TTL로 저장
   * cache.set('session:abc', sessionData, 300);
   *
   * // 만료 없이 저장
   * cache.set('config', configData);
   *
   * // uniqueKey로 중복 방지 (같은 uniqueKey를 가진 이전 항목 삭제)
   * cache.set('request:1', data, 60, 'user:123');
   * cache.set('request:2', data, 60, 'user:123'); // request:1이 삭제됨
   * ```
   */
  set(key, value, ttl = 0, uniqueKey = "") {
    if (uniqueKey) {
      for (const [k, v] of this.cache.entries()) {
        if (v.uniqueKey === uniqueKey) {
          this.cache.delete(k);
        }
      }
    }
    const expiry = ttl ? Date.now() + ttl * 1e3 : 0;
    this.cache.set(key, { value, expiry });
  }
  /**
   * 캐시에서 값을 조회합니다.
   * 만료된 항목은 자동으로 삭제되고 undefined를 반환합니다.
   *
   * @param key - 캐시 키
   * @returns 캐시된 값 또는 만료/미존재 시 undefined
   *
   * @remarks
   * 만료된 값이 dispose() 메서드를 가지고 있으면 자동으로 호출됩니다.
   */
  get(key) {
    const entry = this.cache.get(key);
    if (!entry) {
      return void 0;
    }
    if (entry.expiry && Date.now() > entry.expiry) {
      if (isObject(entry.value) && "dispose" in entry.value && isFunction(entry.value.dispose)) {
        entry.value.dispose();
      }
      this.cache.delete(key);
      return void 0;
    }
    return entry.value;
  }
  /**
   * 캐시에서 특정 항목을 삭제합니다.
   *
   * @param key - 삭제할 캐시 키
   */
  delete(key) {
    this.cache.delete(key);
  }
  /**
   * 캐시의 모든 항목을 삭제합니다.
   */
  clear() {
    this.cache.clear();
  }
};
__name(_TTLCache, "TTLCache");
let TTLCache = _TTLCache;
if (!globalThis.cache) {
  globalThis.cache = new TTLCache();
}
export {
  TTLCache
};
//# sourceMappingURL=ttl-cache.js.map
